import React from 'react';
import { UX2 } from '@wsb/guac-widget-core';
import PropTypes from 'prop-types';
import dataAids from '../../../constants/dataAids';
import { PoyntPaymentRequestButton, ApplePayButton, PaymentRequestButton } from '../';
import { theme } from '../utils/ProductUtils';

const CartButtons = ({
  renderMode,
  category,
  checkout,
  showApplePayButton,
  stripe_config,
  showPoyntPaymentButtons,
  matchingButtonId,
  getOrderData,
  disabled,
  phoneRequired
}) => {
  const { Block } = UX2.Element;
  const stripeButtons = (
    <Block
      style={{
        'display': 'flex',
        'alignItems': 'center',
        'justifyContent': 'flex-end',
        '@xs-only': {
          flexDirection: 'column-reverse',
          width: '100%',
          gap: 'small'
        }
      }}
    >
      { showApplePayButton && (
        <Block style={{ 'marginLeft': 'small', '@xs-only': { marginLeft: 0, width: '100%' } }}>
          { stripe_config.with_payment_request && renderMode === 'PUBLISH' ? (
            <PaymentRequestButton
              initPage='cart'
              styles={{
                paymentRequestButton: {
                  theme: theme({ category }),
                  height: '50px'
                }
              }}
              matchingButtonId={ matchingButtonId }
              getOrderData={ getOrderData }
              phoneRequired={ phoneRequired }
              disabled={ disabled }
              dataAid={ dataAids.CART_PAYMENT_REQUEST }
            />
          ) : (
            <ApplePayButton
              category={ category }
              renderMode={ renderMode }
              initPage='cart'
              disabled={ disabled }
              onClick={ () => {} }
              data-aid={ dataAids.CART_APPLE_PAY }
            />
          ) }
        </Block>
      ) }
      <Block style={{ 'marginLeft': 'small', '@xs-only': { marginLeft: 0, width: '100%' } }}>
        { checkout }
      </Block>
    </Block>
  );

  const poyntButtons = (
    <Block
      style={{
        'display': 'flex',
        'flexDirection': 'row',
        'alignItems': 'center',
        'justifyContent': 'flex-end',
        '@xs-only': {
          flexDirection: 'column',
          width: '100%'
        }
      }}
    >
      <Block style={{ 'marginLeft': 'small', '@xs-only': { marginLeft: 0, width: '100%' } }}>
        <PoyntPaymentRequestButton
          data-aid={ dataAids.CART_POYNT_PAYMENT_REQUEST }
          initPage='cart'
          theme={ theme({ category }) }
          disabled={ disabled }
          getOrderData={ getOrderData }
          phoneRequired={ phoneRequired }
        />
      </Block>
      <Block style={{ 'marginLeft': 'small', '@xs-only': { marginLeft: 0, width: '100%' } }}>
        { checkout }
      </Block>
    </Block>
  );

  return showPoyntPaymentButtons ? poyntButtons : stripeButtons;
};

CartButtons.propTypes = {
  renderMode: PropTypes.string,
  category: PropTypes.string,
  checkout: PropTypes.element,
  showApplePayButton: PropTypes.bool,
  stripe_config: PropTypes.shape({
    with_payment_request: PropTypes.bool
  }),
  showPoyntPaymentButtons: PropTypes.bool,
  matchingButtonId: PropTypes.string,
  getOrderData: PropTypes.func,
  disabled: PropTypes.bool,
  phoneRequired: PropTypes.bool
};

export default CartButtons;
